// extracted by mini-css-extract-plugin
module.exports = {"form":"SkillScoresForm_form__20Dil","totalscoreinput":"SkillScoresForm_totalscoreinput__tJkW7"};